import { createSelector } from 'reselect';
import isEmpty from 'lodash/isEmpty';
import { fromJS } from 'immutable';
import * as appConstants from '../App/constants';

const { SUCCESS } = appConstants;
/**
 * Direct selector to the cap state domain
 */

const selectCapDomain = (state = fromJS({})) => state.get('intouchCap');

/**
 * Other specific selectors
 */

/**
 * Default selector used by Cap
 */

const makeSelectGlobal = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => substate.toJS());

const makeSelectOrg = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => ({
    fetchingUserdata: substate.get('fetchingUserdata'),
    orgID: substate.get('orgID'),
  }));

const makeSelectCap = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => {
    const user = substate.get('user')?.toJS();
    return {
      user: !isEmpty(user) && user,
      currentOrgDetails: substate.get('currentOrgDetails')?.toJS(),
    };
  });

const makeSelectUser = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) =>
    substate.get('user')?.toJS(),
  );

const makeSelectSidebarMenuData = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => {
    const sidebarMenuData = substate.get('sidebarMenuData')?.toJS();
    let parsedMenuData = [];
    if (sidebarMenuData?.status === SUCCESS && sidebarMenuData?.data) {
      parsedMenuData = sidebarMenuData.data;
    }
    return parsedMenuData;
  });

const makeSelectLastSyncData = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => ({
    getLastSyncTimeStatus: substate.get('getLastSyncTimeStatus'),
    lastSyncTime: substate.get('lastSyncTime'),
    lastSyncTimeError: substate.get('lastSyncTimeError'),
  }));

const makeSelectBeamerPostsExploreData = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => ({
    getBeamerPostsExploreStatus: substate.get('getBeamerPostsExploreStatus'),
    beamerPostsExplore: substate.get('beamerPostsExplore')?.toJS(),
    getBeamerPostsExploreError: substate.get('getBeamerPostsExploreError'),
  }));

const makeSelectBeamerPostsNotificationData = () =>
  createSelector(selectCapDomain, (substate = fromJS({})) => ({
    getBeamerPostsNotificationStatus: substate.get(
      'getBeamerPostsNotificationStatus',
    ),
    beamerPostsNotification: substate.get('beamerPostsNotification')?.toJS(),
    getBeamerPostsNotificationError: substate.get(
      'getBeamerPostsNotificationError',
    ),
  }));

export {
  selectCapDomain,
  makeSelectOrg,
  makeSelectCap,
  makeSelectUser,
  makeSelectSidebarMenuData,
  makeSelectLastSyncData,
  makeSelectGlobal,
  makeSelectBeamerPostsExploreData,
  makeSelectBeamerPostsNotificationData,
};
